// @ts-nocheck
import { Injectable } from '@angular/core';
import * as FeatureModule from 'ol/Feature.js';
const Feature = FeatureModule.default as typeof FeatureModule.default;
import { Geometry } from 'ol/geom.js';
import * as VectorLayerModule from 'ol/layer/Vector.js';
const VectorLayer = VectorLayerModule.default as typeof VectorLayerModule.default;
import * as VectorSourceModule from 'ol/source/Vector.js';
const VectorSource = VectorSourceModule.default as typeof VectorSourceModule.default;
import * as IconModule from 'ol/style/Icon.js';
const Icon = IconModule.default as typeof IconModule.default;
import * as FillModule from 'ol/style/Fill.js';
const Fill = FillModule.default as typeof FillModule.default;
import * as StrokeModule from 'ol/style/Stroke.js';
const Stroke = StrokeModule.default as typeof StrokeModule.default;
import * as StyleModule from 'ol/style/Style.js';
const Style = StyleModule.default as typeof StyleModule.default;
import { OLMapService } from './ol-map.service';
import * as GeoJSONModule from 'ol/format/GeoJSON.js';
const GeoJSON = GeoJSONModule.default as typeof GeoJSONModule.default;
import { Control } from 'ol/control.js';
import { EventsKey } from 'ol/events.js';
import { unByKey } from 'ol/Observable.js';

export class LegendControl extends Control { }
export class DetailControl extends Control { }
export class FilterControl extends Control { }

type SelectionOverlayRole = 'active' | 'parent';

@Injectable({
  providedIn: 'root'
})
export abstract class OlAtlasBaseService {
  eventsKey: EventsKey;

  constructor(
    protected olMapService: OLMapService
  ) {
  }

  addVectorLayer(feature: Feature<Geometry>, format: GeoJSON, blackBoundries?: boolean, role: SelectionOverlayRole = 'active') {
    const vectorSource: VectorSource<Geometry> = new VectorSource({
      features: [feature],
      format: format,
    });

    const isParent = role === 'parent' || !!blackBoundries;
    const strokeColor = isParent ? 'rgba(0, 0, 0, 0.95)' : 'rgba(0, 136, 255, 1)';
    const fillColor = isParent ? 'rgba(0, 0, 0, 0.08)' : 'rgba(0, 136, 255, 0.18)';
    const strokeWidth = isParent ? 3 : 3;

    const vector: VectorLayer<VectorSource<Geometry>> = new VectorLayer({
      source: vectorSource,
      style: new Style({
        image: new Icon({
          anchor: [0.5, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: '../../../assets/images/marker-icon.png',
        }),
        fill: new Fill({
          color: fillColor,
        }),
        stroke: new Stroke({
          color: strokeColor,
          width: strokeWidth,
        }),
      }),
      zIndex: isParent ? 10 : 20,
    });

    this.olMapService.layers.push({ name: 'vector', layer: vector });
    this.olMapService.map.addLayer(vector);
  }

  removeVectorLayers() {
    this.olMapService.details = [];
    this.olMapService.detailsLoading = false;
    this.olMapService.layers.forEach((l) => {
      if (l.name === 'vector') {
        this.olMapService.map.removeLayer(l.layer);
      }
    });
    this.olMapService.layers = this.olMapService.layers.filter((l) => l.name !== 'vector');
  }

  getLegends(element: string) {
    const attach = (attempt = 0) => {
      const map = this.olMapService.map;
      const el = document.getElementById(element);
      if (el?.hasAttribute('appMapLegend')) return;

      // The legend lives in a routed child, so it can be created a few frames
      // after the OpenLayers map. Retry briefly instead of leaving it below the map.
      if (!map || !el) {
        if (attempt < 20) {
          setTimeout(() => attach(attempt + 1), 50);
        }
        return;
      }

      map.getControls().forEach((control) => {
        if (control instanceof LegendControl) {
          map.removeControl(control);
        }
      });

      el.classList.add('map-legend-control');
      el.style.position = 'absolute';
      el.style.top = 'auto';
      el.style.right = 'auto';
      el.style.bottom = '0.75rem';
      el.style.left = '0.75rem';
      el.style.zIndex = '1000';
      el.style.margin = '0';
      el.style.pointerEvents = 'auto';

      map.addControl(new LegendControl({ element: el }));
    };

    attach();
  }
  getFilter(element: string) {
    const attach = (attempt = 0) => {
      const map = this.olMapService.map;
      const el = document.getElementById(element);

      // The filter is rendered by a routed child. On narrow screens it can be
      // created shortly after the map, so retry before leaving it in page flow.
      if (!map || !el) {
        if (attempt < 20) {
          setTimeout(() => attach(attempt + 1), 50);
        }
        return;
      }

      if (el.hasAttribute('appMapLegend')) {
        return;
      }

      map.getControls().forEach((control) => {
        if (control instanceof FilterControl) {
          map.removeControl(control);
        }
      });

      el.style.position = 'absolute';
      el.style.top = '0';
      el.style.right = '0';
      el.style.bottom = '0';
      el.style.left = '0';
      el.style.width = '100%';
      el.style.height = '100%';
      el.style.maxWidth = '100%';
      el.style.margin = '0';
      el.style.zIndex = '1400';
      el.style.pointerEvents = 'none';
      el.classList.add('map-filter-control');
      el.setAttribute('aria-label', 'Map filters');

      if (!el.dataset.mapEventsStopped) {
        // Stop events after the target control has handled them. Using capture
        // here would block Angular's click handler on the filter itself.
        const stopMapEvent = (event: Event) => event.stopPropagation();
        for (const eventName of ['click', 'pointerdown', 'mousedown', 'touchstart']) {
          el.addEventListener(eventName, stopMapEvent);
        }
        el.dataset.mapEventsStopped = 'true';
      }


      Array.from(el.children).forEach((child) => {
        if (child instanceof HTMLElement) {
          child.style.pointerEvents = 'auto';
        }
      });

      map.addControl(new FilterControl({ element: el }));
    };

    attach();
  }
  getDetails(element: string) {
    this.olMapService.map.getControls().forEach((c) => {
      if (c instanceof DetailControl) {
        this.olMapService.map.removeControl(c);
      }
    });

    const el = document.getElementById(element);
      if (el?.hasAttribute('appMapLegend')) return;
    if (!el || el.classList.contains('map-container')) {
      return;
    }

    this.olMapService.map.addControl(new DetailControl({
      element: el
    }));
  }

  mapOperationsUn() {
    if (this.eventsKey) {
      unByKey(this.eventsKey);
      this.eventsKey = undefined;
    }
  }
}